import silentAxios from '../../service/axios-silent';

export type PaymentStatusResponse = {
  isPaymented: boolean;
  paymentStatus: string | null;
  paidAmount: number | null;
  paymentTime: string | null;
  transactionId: string | null;
};

const ENTITY = 'app/invoice';
const DEFAULT_POLLING_INTERVAL_MS = 1000;

type StartPollingOptions = {
  invoiceId: string;
  intervalMs?: number;
  onUpdate: (data: PaymentStatusResponse) => void;
  onError?: (error: unknown) => void;
};

export class InvoicePaymentStatusService {
  static getStatus(invoiceId: string): Promise<PaymentStatusResponse> {
    return silentAxios
      .get(`${ENTITY}/${invoiceId}/payment-status`)
      .then((res) => res.data);
  }

  static startPolling({
    invoiceId,
    intervalMs = DEFAULT_POLLING_INTERVAL_MS,
    onUpdate,
    onError,
  }: StartPollingOptions): () => void {
    let cancelled = false;
    let timeoutId: ReturnType<typeof setTimeout> | null = null;

    const stop = () => {
      cancelled = true;
      if (timeoutId) {
        clearTimeout(timeoutId);
        timeoutId = null;
      }
    };

    const poll = async (): Promise<void> => {
      if (cancelled) {
        return;
      }

      try {
        const response = await this.getStatus(invoiceId);
        onUpdate(response);

        if (response.isPaymented) {
          stop();
          return;
        }
      } catch (error) {
        onError?.(error);
        console.error('Error checking payment status:', error);
      }

      if (!cancelled) {
        timeoutId = setTimeout(() => {
          void poll();
        }, intervalMs);
      }
    };

    void poll();

    return stop;
  }
}
